var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"nothing"}},[_c('img',{attrs:{"src":require("../../assets/img/nothing.png"),"alt":""}}),_vm._v(" "+_vm._s(_vm.data)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }